export const auth = {
  authHomeTitle: 'Kom igång',
  authHomeButtonBranded: 'Fortsätt med E-post',
  authHomeButtonApple: 'Fortsätt med Apple',
  authHomeButtonGoogle: 'Fortsätt med Google',
  authHomeButtonFacebook: 'Fortsätt med Facebook',
  authHomeButtonLinkedin: 'Fortsätt med LinkedIn',
  authStartTitle: 'Logga in eller Registrera dig',
  authStartInputTitle: 'E-post',
  authStartInputTitleError: 'Ange en giltig e-postadress!',
  authStartInputPasswordError: 'Ange ett giltigt lösenord!',
  authWhoops: 'Hoppsan!',
  authStartConfirmButton: 'Fortsätt',
  authRegisteredTitle: 'Välkommen tillbaka!',
  authStartPlaceholderTitle: 'E-post',
  authRegisteredInputTitle: 'Lösenord',
  authRegisteredForgotPassword: 'Glömt lösenord',
  authAlertIncorrectPassword: 'Din E-post eller Lösenord är inkorrekt',
  authAlertRequiredPassword: 'Ange ett giltigt lösenord',
  authFinishSignUpTitle: 'Slutför Registrering',
  authFinishSignUpEmailInputTitle: 'E-post',
  authFinishSignUpFirstNameInputTitle: 'Förnamn',
  authFinishSignUpLastNameInputTitle: 'Efternamn',
  authFinishSignUpPasswordInputTitle: 'Lösenord',
  authFinishSignUpTipContent:
    '<ul class="text-14 pl-4 text-black"><li class="-ml-4 list-none">Vi rekommenderar att använda:</li><li class="list-disc">Minst 8 tecken</li><li class="list-disc">Inkludera 1 nummer</li><li class="list-disc">Inkludera 1 specialtecken</li></ul>',
  authFinishSignUpPrivacyAndTerms: {
    text1: 'Genom att klicka på Registrera godkänner du vår',
    privacyPolicy: 'Integritetspolicy',
    text2: 'och',
    termsOfUse: 'Användarvillkor'
  },
  authFinishSignUpConfirmButton: 'Registrera',
  authFinishSignUpErrorFirstName: 'Förnamn får inte vara tomt!',
  authFinishSignUpErrorLastName: 'Efternamn får inte vara tomt!',
  authFinishSignUpErrorPassword: 'Lösenordet är för kort!',
  authEmailConfirmationTitle: 'Kontrollera din inkorg',
  authEmailConfirmationContent:
    'Vi har skickat ett bekräftelsemail för att verifiera din e-postadress. Se även till att kolla din skräppost om du inte hittar det i din inkorg.',
  authEmailConfirmationConfirmButton: 'Tillbaka till Inloggning',
  authAlertEmailConfirmation: 'Kontrollera din inkorg för att bekräfta din e-postadress!',
  authResetPasswordTitle: 'Kontrollera din inkorg',
  authResetPasswordDescription:
    'Vi har skickat en länk för att återställa ditt lösenord till din e-postadress. Se även till att kolla din skräppost om du inte hittar det i din inkorg.',
  authResetPasswordButton: 'Tillbaka till inloggning',
  authNewPasswordTitle: 'Ange nytt lösenord',
  authNewPasswordInputTitle: 'Nytt lösenord',
  authNewPasswordButton: 'Återställ lösenord',
  authNewPasswordAlertValidation: 'Ditt lösenord är inte tillräckligt starkt',
  authPasswordChangeSuccessTitle: 'Lösenord ändrat!',
  authPasswordChangeSuccessContent: 'Ditt lösenord har ändrats!',
  authPasswordChangeSuccessButton: 'Tillbaka till inloggning',
  authPasswordChangeErrorTitle: 'Fel!',
  authPasswordChangeErrorContent: 'Något gick fel när du försökte återställa ditt lösenord! Försök igen senare.',
  authPasswordChangeErrorButton: 'Tillbaka till inloggning',
  authInvitationTitle: 'Välj ett lösenord',
  authInvitationInputTitle: 'Lösenord',
  authInvitationButton: 'Ställ in lösenord',
  authEmailAddressConfirmed: 'E-postadress bekräftad!'
}
